module.exports = __webpack_public_path__ + "static/media/ic_bank_details.4db4b780.png";